import VisitasIndex from '../visitas/pages/VisitasIndex.vue';
import { laisPath } from '../laisRouteHelpers';

export default {
  path: laisPath('minhas-chaves'),
  component: VisitasIndex,
};
